import { z } from 'zod';
import { skillCategorySchema } from './common.js';
import {
  strapiCertificationBaseSchema,
  strapiExperienceBaseSchema,
  strapiProjectBaseSchema,
  strapiSkillBaseSchema,
} from './base.js';

export const strapiSkillSchema = strapiSkillBaseSchema.extend({
  categories: z.array(skillCategorySchema),
  certifications: z.array(strapiCertificationBaseSchema).nullish(),
  projects: z.array(strapiProjectBaseSchema).nullish(),
  experiences: z.array(strapiExperienceBaseSchema).nullish(),
});

export type StrapiSkillResponse = z.infer<typeof strapiSkillSchema>;
